<div class="sokoban">
  <div class="level">Level {{ currentLevel + 1 }}</div>
  <div class="board">
    <div *ngFor="let row of grid; let r = index" class="row">
      <div *ngFor="let cell of row; let c = index" class="cell"
          [ngClass]="getClasses(r, c)">
        {{ getChar(r, c) }}
      </div>
    </div>
  </div>
  <div class="status">Packets: {{ packets }} | Moves: {{ moves }}</div>
  <div class="controls">
    <button (click)="undo()">Undo (Z)</button>
    <button (click)="loadLevel(currentLevel)">Reset (R)</button>
    <button (click)="resetProgress()">Reset Progress</button>
  </div>
  <div class="dpad">
    <div class="dpad-row">
      <button (click)="move(-1, 0)">🡹</button>
    </div>
    <div class="dpad-row">
      <button (click)="move(0, -1)">🡸</button>
      <button class="invisible"></button>
      <button (click)="move(0, 1)">🡺</button>
    </div>
    <div class="dpad-row">
      <button (click)="move(1, 0)">🡻</button>
    </div>
  </div>
</div>